import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "size", "offset"];
import { forwardRef } from 'react';
import styled from 'foundations-theming/utils';
import { generateResponsiveStyles } from './Grid.helpers';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledGridItem = styled.div.withConfig({
  displayName: "GridItem__StyledGridItem",
  componentId: "sc-133uehm-0"
})(props => {
  const theme = props.theme;
  return Object.assign({
    boxSizing: 'border-box',
    flexGrow: 0,
    flexShrink: 0,
    maxWidth: '100%',
    paddingInline: theme.space['400']
  }, props.$size ? generateResponsiveStyles(props.$size) : {}, props.$offset ? generateResponsiveStyles(props.$offset, true) : {}, props.$cssStyles);
});
export const GridItem = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      children,
      size = 0,
      offset = 0
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps
  } = filterProps(restProps);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(StyledGridItem, Object.assign({
    $size: size,
    $offset: offset,
    $cssStyles: cssStyles,
    ref: ref
  }, domProps, {
    children: children
  }));
});